"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebarTracking_vue_1 = __importDefault(require("../../Layout/SidebarTracking.vue"));
const TopbarTracking_vue_1 = __importDefault(require("../../Layout/TopbarTracking.vue"));
const TrialsConfigurationYield_vue_1 = __importDefault(require("./Yield/TrialsConfigurationYield.vue"));
let TrialsConfigurationView = class TrialsConfigurationView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.data = null;
        this.sidebar_selected = 'proposals';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    loadView(u) {
        switch (u) {
            case 'home':
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
            case 'proposals':
                this.sidebar_selected = 'proposals';
                window.location.href = '/tracking/proposalslist';
                break;
            default:
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
        }
    }
    launchCrumb(c) {
        if (c === 'home') {
            window.location.href = '/tracking/';
        }
        let url;
        if (window.location.href.split('?')[0]) {
            url = new URL(window.location.href.split('?')[0]);
        }
        window.history.pushState({}, '', url);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsConfigurationView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TrialsConfigurationView.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TrialsConfigurationView.prototype, "data", void 0);
TrialsConfigurationView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            SidebarTracking: SidebarTracking_vue_1.default,
            TopbarTracking: TopbarTracking_vue_1.default,
            TrialsConfigurationYield: TrialsConfigurationYield_vue_1.default,
        },
    })
], TrialsConfigurationView);
exports.default = TrialsConfigurationView;
